<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="moreDocumentationReason"><strong>Message to appear in email (visible to claimant!)</strong></label>
                    <wysiwyg id="moreDocumentationReason" v-model="moreDocumentationReason" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="">
                    <p>Select the type of documents that you wish the claimant to provide.</p>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label"
                               :for="'selectedTemplate'">
                            Document type group
                        </label>
                        <div class="col-sm-8">
                            <b-form-select v-model="selectedTemplate" :options="templates" size="sm" class="">
                                <template slot="first">
                                    <option :value="null" disabled>-- Please select a document type group --</option>
                                </template>
                            </b-form-select>
                        </div>
                    </div>
                    <p><a href="javascript:void(0)" @click="handleShowTipsLinkClick">{{showTipsLinkText}}</a></p>
                    <p style="padding-left: 5px;"><i class="fas fa-info-circle mr-2"></i>Tips will appear in the email to the customer.</p>
                    <div v-for="(type, index) in documentTypes" :key="index" class="form-check">
                        <label class="form-check-label">
                            <input type="checkbox"
                                   class="form-check-input mb-2"
                                   @click="handleDocumentTypeClick(type)"
                                   :checked="documentTypeSelected(type.id)"
                                   value="">{{type.label}}
                        </label>
                        <transition name="fade">
                            <textarea v-if="showTips" id="" class="form-control form-control-sm mb-2" rows="4" :value="type.tip" disabled></textarea>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="float-right">
                    <button type="button" class="btn btn-primary mr-2" @click="handleRequestMoreDocsPreviewClick()">Preview Send More Docs email</button>
                    <button type="button" class="btn btn-primary" @click="handleRequestMoreDocsClick()">Send More Docs email</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions } from 'vuex'
    export default {
        name: 'ClaimApprovePopoutTabs',
        components: {
            
        },
        data: () => {
            return {
                moreDocumentationReason: null,
                selectedDocumentTypes: [],
                showTips: false,
                selectedTemplate: null,

                templates: [{
                    value: [1000],
                    text: 'POP'
                },
                {
                    value: [1003],
                    text: 'POD'
                },
                {
                    value: [1005],
                    text: 'POP'
                },
                {
                    value: [1000, 1003],
                    text: 'POP_POD'
                },
                {
                    value: [1003, 1005],
                    text: 'POD_POU'
                },
                {
                    value: [1000, 1003, 1005],
                    text: 'POP_POD_POU'
                },
                {
                    value: [1004],
                    text: 'POT'
                },
                {
                    value: [1005],
                    text: 'POU'
                },
                {
                    value: [1006],
                    text: 'POI'
                },
                {
                    value: [1000, 1004],
                    text: 'POP_POT'
                },
                {
                    value: [1000, 1006],
                    text: 'POP_POI'
                },
                {
                    value: [1000, 1003, 1004],
                    text: 'POP_POD_POT'
                },
                {
                    value: [1000, 1003, 1005, 1006],
                    text: 'POP_POD_POU_POI'
                },
                {
                    value: [1000, 1003, 1005, 1006, 1004],
                    text: 'POP_POD_POU_POI_POT'
                },
                {
                    value: [1000, 1003, 1004, 1006],
                    text: 'POP_POD_POT_POI'
                },
                {
                    value: [1000, 1003, 1006],
                    text: 'POP_POD_POI'
                },
                {
                    value: [1003,1004],
                    text: 'POD_POT'
                },
                {
                    value: [1004,1006],
                    text: 'POT_POI'
                }]
            }
        },
        watch: {
            'selectedTemplate': function (newVal) {
                if (newVal) {
                    this.selectedDocumentTypes = []
                    for (let i = 0; i < newVal.length; i++) {
                        let item = this.documentTypes.find(o => o.id == newVal[i])
                        if (item) 
                            this.selectedDocumentTypes.push(item)
                    }
                }
            }
        },
        computed: {
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            documentTypes() {
                return this.$store.getters.documentTypes
            },
            emailPreview() {
                return this.$store.getters.emailPreview
            },
            showTipsLinkText() {
                return this.showTips ? '[- Hide document type tips below]' : '[+ Show document type tips below]'
            }
        },
        methods: {
            ...mapActions([
                'requestMoreDocs',
                'requestMoreDocsEmailPreview',
                'resetEmailPreview'
            ]),
            handleRequestMoreDocsClick() {
                let { claimId } = this.selectedClaim
                let { selectedDocumentTypes } = this
                this.selectedDocumentTypes = []
                let { moreDocumentationReason } = this
                let sendEmail = true

                this.requestMoreDocs({ claimId, selectedDocumentTypes, reason: moreDocumentationReason, sendEmail })
            },
            handleRequestMoreDocsPreviewClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim
                let { selectedDocumentTypes } = this
                let { moreDocumentationReason } = this
                let sendEmail = true

                this.requestMoreDocsEmailPreview({ claimId, selectedDocumentTypes, reason: moreDocumentationReason, sendEmail })

                this.$nextTick(() => {
                    //this.$bvModal.show('previewEmailModal1')
                    this.$emit('previewClicked')
                })
            },
            handleDocumentTypeClick(item) {
                if (this.selectedDocumentTypes.includes(item)) {
                    this.selectedDocumentTypes.splice(this.selectedDocumentTypes.indexOf(item), 1)
                } else {
                    this.selectedDocumentTypes.push(item)
                }
                this.selectedTemplate = null
            },
            getBlobURL(code, type) {
                const blob = new Blob([code], { type })
                return URL.createObjectURL(blob)
            },
            handleShowTipsLinkClick() {
                this.showTips = !this.showTips
            },
            documentTypeSelected(id) {
                for (var i = 0; i < this.selectedDocumentTypes.length; i++) {
                if (this.selectedDocumentTypes[i].id === id) {
                  return true
                }
              }
              return false
            }
        }
    }
</script>